@if (setting) {
  <app-header></app-header>
  <div class="container-fluid" style="min-height:87vh">
    <hr>
    @if (_userService.token) {
      <div class="spacer">
        <div class="alert alert-info" role="alert">
          <p>
            You are logged in as {{ _userService.username }}. <br>
            Token Expires: {{ _userService.token_expires }}
          </p>
          <button mat-raised-button color="primary" (click)="_userService.refreshToken()">Refresh Token</button>&nbsp;
          <button mat-raised-button color="primary" (click)="logout()">Log Out</button>
        </div>
      </div>
    }
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" class="spacer">
      <div fxFlex="50">
        <img src="{{setting['image']['url']}}" alt="Project Logo"
             [ngClass]="{'small-project-logo':project==='AQUA-FAANG' || project==='BovReg', 'large-project-logo':project!=='AQUA-FAANG' && project!=='BovReg'}">
      </div>
      <div fxFlex="50">
        <img src="{{ project === 'Bovine' || project === 'USPIGFAANG' ? right_logo_url['bovine'] : right_logo_url['other'] }}"
             alt="Funding Logo"
             [ngClass]="project!=='AQUA-FAANG' && project!=='BovReg' ? 'large-project-logo funding-logo' : 'small-project-logo funding-logo'">
      </div>
    </div>
    <h3 class="spacer">
      <a href="{{setting['url']}}">{{setting['url']}}</a>
    </h3>
    @if (!_userService.token && project === 'BovReg') {
      <div
        fxLayout="row" fxLayout.lt-md="column" style="margin-bottom: 30px;">
        <button mat-raised-button color="primary" (click)="login()">Login to BovReg Portal</button>
      </div>
    }
    @if (project !== 'EuroFAANG') {
      <div class="spacer" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="5%">
        @if (project === 'Bovine') {
          <mat-card class="card scroll" fxFlex="50" fxFlex.lt-md="100">
            <h5>{{setting['description']}}</h5>
          </mat-card>
        }
        @if (project !== 'Bovine') {
          <mat-card class="card" fxFlex="50" fxFlex.lt-md="100" style="padding: 30px;">
            <h5>{{setting['description']}}</h5>
          </mat-card>
        }
        <!--        <mat-card class="card" fxFlex="50" fxFlex.lt-md="100" *ngIf="project !== 'Bovine'" style="text-align: right;">-->
        <!--          <a class="twitter-timeline" href="https://twitter.com/{{setting.twitter.id}}?ref_src=twsrc%5Etfw"-->
        <!--             data-height="300"-->
        <!--             data-theme="light"-->
        <!--             data-width="100%"-->
        <!--             data-chrome="noborders nofooter noscrollbar transparent"-->
        <!--          >-->
        <!--            Tweets by {{setting.twitter.id}}-->
        <!--          </a>-->
        <!--          <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>-->
        <!--        </mat-card>-->
      </div>
      <!--      <div class="project-link">-->
        <!--        For more information on the {{project}} project: <a href="{{project_links[project]}}" target='_blank'>-->
        <!--        {{project}} </a>-->
        <!--      </div>-->
      <div style="margin-bottom: 40px;"></div>


      <div #ensemblannotation></div>
      @defer (on viewport(ensemblannotation)){
        <app-ensembl-annotation [projectArr]="[project]"></app-ensembl-annotation>
      } @placeholder {
        <div>Loading..</div>
      }

      <!-- Related Tables -->
      @for (table of relatedTables; track table) {
        @defer (on viewport) {
          <app-related-items source_type="project" [target_type]=table download_key=""
                             [record_id]="project"></app-related-items>
        } @placeholder {
          <div>loading table</div>
        }
      }


      <!-- Related Protocols -->
      @if (getTotalEnabledStatus()) {
        <h3
          style="margin-bottom: 20px;">
          Related Protocols
        </h3>
      }
      <mat-tab-group animationDuration="0ms" [selectedIndex]="getSelectedTab()">
        @for (targetType of tabs; track targetType) {
          <mat-tab [label]="tabsConfig[targetType].title" [labelClass]="getEnabledStatus(targetType) ? '' : 'hidden-tab'">
            <app-related-items
              source_type="project"
              [target_type]="targetType"
              download_key=""
              [record_id]="project"
              (fetchedRecords)="enableTab($event)"
            ></app-related-items>
          </mat-tab>
        }
      </mat-tab-group>
    } @else {
      <app-eurofaang-info></app-eurofaang-info>
    }
  </div>
}
